import type { DeleteAccountPayload, Profile, UpdatePasswordPayload, UpdateProfilePayload } from "api";
import { DeleteAccountCard } from "./DeleteAccountCard";
import { PasswordForm } from "./PasswordForm";
import { ProfileForm } from "./ProfileForm";
import { SignInMethodCard } from "./SignInMethodCard";

type SettingsPaneProps = {
  profile: Profile;
  onSave: (payload: UpdateProfilePayload) => Promise<string | null>;
  onChangePassword: (payload: UpdatePasswordPayload) => Promise<string | null>;
  onDelete: (payload: DeleteAccountPayload) => Promise<string | null>;
};

export const SettingsPane = ({ profile, onSave, onChangePassword, onDelete }: SettingsPaneProps) => (
  <div className="pc-pane">
    <ProfileForm profile={profile} onSave={onSave} />

    {profile.provider === null ? (
      <PasswordForm onSubmit={onChangePassword} />
    ) : (
      <SignInMethodCard provider={profile.provider} email={profile.email} />
    )}

    <DeleteAccountCard needsPassword={profile.provider === null} onDelete={onDelete} />
  </div>
);
